module.exports = __webpack_public_path__ + "img/logo.1ab9bee0.png";